interface PathLocationLike {
  pathname: string;
  search?: string;
  hash?: string;
}

export const buildCurrentPath = ({
  pathname,
  search = "",
  hash = "",
}: PathLocationLike) => `${pathname}${search}${hash}`;
